import Vue from 'vue'
import Router from 'vue-router'
import Login from 'views/login/index'
import forgetPassword from 'views/login/components/forgetPassword'
import registeredNumber from 'views/login/components/registeredNumber'
import answerRegister from 'views/outsideranswer/AnswerRegister' //校外人员电脑答题登记
import outsiderAnswerList from 'views/outsideranswer/OutsiderAnswerList' //校外人员答题列表
import outsiderAnswer from 'views/outsideranswer/OutsiderAnswer' //校外人员答题

import Layout from 'views/layout/Layout'
import store from '@/store/index'
import {
    Message,
    MessageBox
} from 'element-ui'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const routes = [{
        path: '/',
        redirect: '/home'
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/forgetPassword',
        name: 'forgetPassword',
        component: forgetPassword
    }, {
        path: '/registeredNumber',
        name: 'registeredNumber',
        component: registeredNumber
    },
    {
        path: '/answerRegister',
        name: 'answerRegister',
        component: answerRegister

    },
    {
        path: '/outsiderAnswerList',
        name: 'outsiderAnswerList',
        component: outsiderAnswerList

    },
    {
        path: '/outsiderAnswer',
        name: 'outsiderAnswer',
        component: outsiderAnswer

    },
    {
        path: '/',
        component: Layout,
        children: [{
                path: '/home',
                name: 'home',
                component: () =>
                    import ('views/homechild/syshome')
            },
            {
                path: '/schoolHome',
                name: 'schoolHome',
                component: () =>
                    import ('views/homechild/schoolhome')
            },
            {
                path: '/sysmgr/user',
                name: 'user',
                component: () =>
                    import ('views/sysmgr/user/index')
            },
            {
                path: '/sysmgr/role',
                name: 'role',
                component: () =>
                    import ('views/sysmgr/role/index')
            },
            {
                path: '/sysmgr/menu',
                name: 'menu',
                component: () =>
                    import ('views/sysmgr/menu/index')
            },
            // 组织机构管理
            {
                path: '/sysmgr/organization',
                name: 'organization',
                component: () =>
                    import ('views/sysmgr/organization/index')
            },
            {
                path: '/sysmgr/area',
                name: 'area',
                component: () =>
                    import ('views/sysmgr/area/index')
            },
            {
                path: '/edumgr/education',
                name: 'education',
                component: () =>
                    import ('views/edumgr/education/index')
            },

            {
                path: '/sysmgr/myTask',
                name: 'myTask',
                component: () =>
                    import ('views/sysmgr/task/MyTask')
            },
            {
                path: '/sysmgr/addTask',
                name: 'addTask',
                component: () =>
                    import ('views/sysmgr/task/AddTask')
            },
            {
                path: '/sysmgr/addPsychologyTask',
                name: 'addPsychologyTask',
                component: () =>
                    import ('views/sysmgr/task/addPsychologyTask')
            },
            {
                path: '/sysmgr/scale',
                name: 'scale',
                component: () =>
                    import ('views/sysmgr/scale/index')
            },
            // 量表设置
            {
                path: '/sysmgr/scaleSetting',
                name: 'scaleSetting',
                component: () =>
                    import ('views/sysmgr/scalesetting/index')
            },
            // 量表套餐管理
            {
                path: '/sysmgr/scalePackage',
                name: 'scalePackage',
                component: () =>
                    import ('views/sysmgr/scalepackage/index')
            },
            {
                path: '/answermgr/answerList',
                name: 'answerList',
                component: () =>
                    import ('views/answermgr/answer/index')
            },
            {
                path: '/psychology/classmgr',
                name: 'classmgr',
                component: () =>
                    import ('views/psychology/classmgr/index')
            },
            {
                path: '/psychology/mystudy',
                name: 'mystudy',
                component: () =>
                    import ('views/psychology/mystudy/index')
            },
            {
                name: 'courseDetail',
                path: '/psychoEvaluation/courseDetail',
                component: () =>
                    import ('views/psychologyEvaluation/components/courseDetail')
            },
            {
                path: '/psychoEvaluation/courseList',
                name: 'courseList',
                component: () =>
                    import ('views/psychologyEvaluation/components/courseList')
            },
            {
                path: '/psychoEvaluation/record',
                name: 'evaluateList',
                component: () =>
                    import ('views/psychologyEvaluation/record')
            },
            {
                path: '/psychoEvaluation/answer',
                name: 'answer',
                component: () =>
                    import ('views/psychologyEvaluation/components/answer')
            },
            {
                path: '/psychologyTrain/trainquery',
                name: 'trainquery',
                component: () =>
                    import ('views/psychologyTrain/trainquery/index')
            },
            {
                path: '/psychologyTrain/myTrain',
                name: 'myTrain',
                component: () =>
                    import ('views/psychologyTrain/myTrain/index')
            },
            {
                path: '/psychologyTrain/trainList',
                name: 'trainList',
                component: () =>
                    import ('views/psychologyTrain/components/trainList')
            },
            {
                name: 'trainDetail',
                path: '/psychologyTrain/trainDetail',
                component: () =>
                    import ('views/psychologyTrain/components/trainDetail')
            },
            // 我的测评
            {
                path: '/psychologyEvaluation/myEvaluation',
                name: 'myEvaluation',
                component: () =>
                    import ('views/psychologyEvaluation/myEvaluation/index')
            },
            //调查问卷页面
            {
                path: '/psychologyEvaluation/questionnaire',
                name: 'questionnaire',
                component: () =>
                    import ('views/psychologyEvaluation/questionnaire/index')
            },
            // 重点关注对象
            {
                path: '/psychologyEvaluation/focus',
                name: 'focus',
                component: () =>
                    import ('views/psychologyEvaluation/focus/index')
            },
            // 心理测评
            {
                path: '/psychologyEvaluation/evaQuery',
                name: 'evaQuery',
                component: () =>
                    import ('views/psychologyEvaluation/evaquery/index')
            },
            // 测评告警
            {
                path: '/psychologyEvaluation/warning',
                name: 'warning',
                component: () =>
                    import ('views/psychologyEvaluation/warning/index')
            },
            //  添加任务选择人员界面
            {
                path: '/sysmgr/selectStudent',
                name: 'selectStudent',
                component: () =>
                    import ('views/sysmgr/task/SelectStudent')
            },
            //  添加任务选择量表界面
            {
                path: '/sysmgr/selectScale',
                name: 'selectScale',
                component: () =>
                    import ('views/sysmgr/task/SelectScale')
            },
            // 选择测评量表
            {
                path: '/outsidermgr/currentScale',
                name: 'currentScale',
                component: () =>
                    import ('views/outsidermgr/CurrentScale')
            },

            // 校外人员名单查询
            {
                path: '/outsidermgr/outsiderQuery',
                name: 'outsiderQuery',
                component: () =>
                    import ('views/outsidermgr/OutsiderQuery')
            },
            // 初次辅导查询
            {
                path: '/outsidermgr/psychologyCoach/coachQuery',
                name: 'coachQuery',
                component: () =>
                    import ('views/outsidermgr/CoachQuery')
            },
            // 二次辅导查询
            {
                path: '/outsidermgr/psychologyCoach/secondCoachQuery',
                name: 'secondCoachQuery',
                component: () =>
                    import ('views/outsidermgr/secondCoachQuery')
            },
            // 辅导调查问卷页面
            {
                path: '/outsidermgr/coachQuestionnaire',
                name: 'coachQuestionnaire',
                component: () =>
                    import ('views/outsidermgr/CoachQuestionnaire')
            },

        ]
    },
    // 档案管理
    {
        path: '/archivesmgr',
        component: Layout,
        children: [
            //  人员管理
            {
                path: '/archivesmgr/personnel',
                name: 'personnel',
                component: () =>
                    import ('views/archivesmgr/personnel/index')
            },
            //档案管理
            {
                path: '/archivesmgr/archives',
                name: 'archives',
                component: () =>
                    import ('views/archivesmgr/archives/index')
            },
        ]
    },
    // 任务管理
    {
        path: '/task',
        component: Layout,
        children: [
            // 系统任务
            {
                path: 'systemTask',
                name: 'systemTask',
                component: () =>
                    import ('views/taskmgr/systemTask')
            },
            // 教育局任务
            {
                path: 'educationTask',
                name: 'educationTask',
                component: () =>
                    import ('views/taskmgr/educationTask')
            },
            // 学校任务
            {
                path: 'schoolTask',
                name: 'schoolTask',
                component: () =>
                    import ('views/taskmgr/schoolTask')
            },
            // 心理老师任务
            {
                path: 'psychologyTask',
                name: 'psychologyTask',
                component: () =>
                    import ('views/taskmgr/psychologyTask')
            },
            // 历史任务
            {
                path: 'historyTask',
                name: 'historyTask',
                component: () =>
                    import ('views/taskmgr/historyTask')
            },
            // 任务图形分析
            {
                path: 'taskEchartsDetails',
                name: 'taskEchartsDetails',
                component: () =>
                    import ('views/taskmgr/taskEchartsDetails')
            },
            // 人员任务
            // 任务重做
            {
                path: 'reform',
                name: 'reform',
                component: () =>
                    import ('views/taskmgr/reform/studentSelect')
            },
            // 心理老师测评任务
            {
                path: 'teacherTask',
                name: 'teacherTask',
                component: () =>
                    import ('views/taskmgr/teacherTask')
            },
            // 心理老师历史测评任务
            {
                path: 'teacherHistoryTask',
                name: 'teacherHistoryTask',
                component: () =>
                    import ('views/taskmgr/teacherHistoryTask')
            },
            // 添加心理老师测评任务
            {
                path: 'addTeacherTask',
                name: 'addTeacherTask',
                component: () =>
                    import ('views/taskmgr/addTeacherEvaluateTask')
            },
            // 教育局测评任务列表
            {
                path: 'eduTask',
                name: 'eduTask',
                component: () =>
                    import ('views/taskmgr/eduTask')
            },
            // 添加教育局测评任务
            {
                path: 'addEduTask',
                name: 'addEduTask',
                component: () =>
                    import ('views/taskmgr/addEduTask')
            }
        ]
    },
    // 心理访谈
    {
        path: '/interviewmgr',
        component: Layout,
        children: [
            // 初次辅导人员列表
            {
                path: 'firstinterviewpel',
                name: 'firstinterviewpel',
                component: () =>
                    import ('views/interviewmgr/firstinterviewpel/index')
            },
            {
                path: 'againinterviewpel',
                name: 'againinterviewpel',
                component: () =>
                    import ('views/interviewmgr/againinterviewpel/index')
            },
            // 访谈记录查询
            {
                path: 'interviewquery',
                name: 'interviewquery',
                component: () =>
                    import ('views/interviewmgr/interviewquery/index')
            }
            // {
            //     path: 'secondInterview', // 二次访谈 
            //     name: 'secondInterview',
            //     component: () =>
            //         import ('views/interview/secondinterview/index')
            // }
        ]
    },
    //校外人员管理路由配置
    {
        path: '/outsidermgr',
        component: Layout,
        children: [
            // 心理测评
            {
                path: 'psychologyEvaluationOutside',
                name: 'psychologyEvaluationOutside',
                component: () =>
                    import ('views/outsidermgr/Registration'),
                children: [{
                    path: 'registration',
                    name: 'registration',
                    component: () =>
                        import ('views/outsidermgr/Registration')
                }]
            },
            // 心理辅导
            {
                path: 'psychologyCoach',
                name: 'psychologyCoach',
                component: () =>
                    import ('views/outsidermgr/CoachRegister'),
                children: [
                    // 辅导登记
                    {
                        path: 'coachRegister',
                        name: 'coachRegister',
                        component: () =>
                            import ('views/outsidermgr/CoachRegister')
                    },
                ]
            },
        ]
    },
    // 重点人员
    {
        path: '/',
        component: Layout,
        children: [{
            path: '/keyPersonnel',
            name: 'keyPersonnel',
            component: () =>
                import ('views/keyPersonnel/index')
        }],
    },
    // 教育厅、教育局管理
    {
        path: '/education',
        component: Layout,
        children: [{
            path: 'department',
            name: 'educationDepartmentList',
            component: () =>
                import ('views/edumgr/department/index')
        }],
    }
]

const router = new Router({
    routes,
    mode: 'history'
})

const whiteList = ['/login', '/forgetPassword', '/registeredNumber', '/answerRegister', '/outsiderAnswerList', '/outsiderAnswer', '/task/reform'] // 不重定向白名单
router.beforeEach((to, from, next) => {
    if (LYCom.GetToken()) {
        if (to.path === '/login') {
            next({
                path: '/'
            })
        } else {
            if (store.getters.role == null) {
                store.dispatch('GetInfo').then(res => { // 拉取用户信息
                    let permisions = {
                        'menus': res.menus,
                        'schools': res.schools,
                        'currentSchool': res.selected_school,
                        'currentRoleGroup': res.CurrentRoleGroup,
                        'currentOrganizationId': res.CurrentOrganizationId,
                        'currentOrganizationName': res.CurrentOrganizationName
                    }
                    store.dispatch('GeneratePermisions', permisions)
                        //获取首页
                    if (to.name == 'home') {
                        let first = res.menus.find(e => e.name == 'home')
                        if (first) {
                            next(first.url)
                        }
                        // 如果是人员跳转到我的任务
                        if (res.role_id == 4) {
                            next('/sysmgr/myTask')
                        }
                    }
                    next()
                }).catch((err) => {
                    store.dispatch('FedLogOut').then(() => {
                        let errMsg = '验证失败, 请重新登录'
                        if (err) {
                            errMsg = err.toString()
                        }
                        Message.error(errMsg)
                        next({
                            path: '/'
                        })
                    })
                })
            } else {
                next()
            }
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            next('/login')
        }
    }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js